export type PreviewRole = "agent" | "client" | "co_buyer" | "mls_admin";

export interface PreviewRoleOption {
  role: PreviewRole;
  label: string;
  description: string;
  /** Where to land when entering this preview */
  home: string;
}

export const PREVIEW_ROLE_OPTIONS: PreviewRoleOption[] = [
  {
    role: "client",
    label: "Buyer (Client)",
    description: "Standard buyer account",
    home: "/client-dashboard",
  },
  {
    role: "co_buyer",
    label: "Co-Buyer",
    description: "Shared buyer access",
    home: "/client-dashboard",
  },
  {
    role: "agent",
    label: "Agent",
    description: "Listing and client tools",
    home: "/agent-dashboard",
  },
  {
    role: "mls_admin",
    label: "MLS Admin",
    description: "Feed and data management",
    home: "/mls-admin",
  },
];

export const previewRoleLabel = (role: string | null | undefined) =>
  PREVIEW_ROLE_OPTIONS.find((o) => o.role === role)?.label ?? role ?? "";

export const previewRoleHome = (role: string | null | undefined) =>
  PREVIEW_ROLE_OPTIONS.find((o) => o.role === role)?.home ?? "/";
